import request from "@/utils/request";

// 创建党建引领
export const createZhengc = (data) => {
    return request({
        url: "/businessservice/zhengce/create",
        method: "post",
        data: data
    })
}

// 创建党建引领
export const updateZhengc = (data) => {
    return request({
        url: "/businessservice/zhengce/update",
        method: "post",
        data: data
    })
}

// 创建党建引领
export const pageZhengc = (data) => {
    return request({
        url: "/businessservice/zhengce/page",
        method: "post",
        data: data
    })
}

// 查询党建引领信息
export const  infoZhengc =(query) =>{
    return request({
        url: "/businessservice/zhengce/info",
        method:"get",
        params: query
    })
}

// 删除党建引领信息
export const  deleteZhengc =(query) =>{
    return request({
        url: "/businessservice/zhengce/delete",
        method:"get",
        params: query
    })
}

// 置顶党建引领信息
export const  topZhengc =(query) =>{
    return request({
        url: "/businessservice/zhengce/top",
        method:"get",
        params: query
    })
}